import React, { useState, useEffect, CSSProperties, useContext, useMemo } from "react";
import LeaderBoardShow from "./LeaderBoardShow";
import QuestContext from "../../../../components/QuestWrapper";
import General from "../../../../general";
import { BrandTheme } from "../../Survey/types/SurveyTypesOffline";
import { QuestThemeData } from "./leaderBoardTypes";
import LeaderboardThemeManager from "./LeaderboardThemeManager";


interface LeaderboardData {
  userId: string;
  imageUrl?: string;
  runningXP: number;
  name?: string;
  streak?: string;
  counter?: number | null;
  externalUserId?: string;
}

interface MembershipTier {
  isEnabled: boolean;
  xp: number;
  rewards: string[];
  _id: string;
  entityId: string;
  membershipTier: number;
  xpThreshold: number;
  description: string;
  imageIPFS?: string;
  createdAt: string;
  __v: number;
  imageUrl?: string;
}

export interface StyleConfig {
  Form?: CSSProperties;
  MainHeading?: CSSProperties;
  Heading?: CSSProperties;
  Description?: CSSProperties;
  PointsBackground?: CSSProperties;
  PointsColor?: CSSProperties;
  InnerBackground?: CSSProperties;
  IndexColor?: CSSProperties;
  IndexBackground?: CSSProperties;
  ProgressBarColor?: CSSProperties;
  IconStyle?: {
    color?: string;
  };
  Footer?: {
    FooterStyle?: CSSProperties;
    FooterTextStyle?: CSSProperties;
    FooterIcon?: CSSProperties;
    FooterText?: string;
    FooterLink?: string;
  };
  PresentUser?: CSSProperties;
}

interface LeaderBoardProps {
  styleConfig?: StyleConfig;
  offlineFormData?: LeaderboardData[];
  BrandTheme?: BrandTheme;
  QuestThemeData?: QuestThemeData;
  FirstRankIconImage?: string;
  SecondRankIconImage?: string;
  ThirdRankIconImage?: string;
  IsTopRank?: boolean;
  isXpImage?: boolean;
  rewardHead?: string;
  presentUserRank?: number | null;
  showFooter?: boolean;
  onUserClick?: (userData: LeaderboardData) => void;
  customUnit?: string;
  customUnitImage?: string;
}

const LeaderBoardOffline: React.FC<LeaderBoardProps> = ({
  styleConfig,
  offlineFormData = [],
  BrandTheme,
  QuestThemeData,
  FirstRankIconImage,
  SecondRankIconImage,
  ThirdRankIconImage,
  IsTopRank,
  isXpImage,
  rewardHead,
  presentUserRank,
  showFooter = true,
  onUserClick,
  customUnit,
  customUnitImage
}) => {
  const [leaderboardData, setLeaderboardData] = useState({
    data: offlineFormData,
  });
  const themeManager = useMemo(() => {
    return new LeaderboardThemeManager(
      {},
      styleConfig,
      QuestThemeData,
      BrandTheme
    );
  }, [styleConfig, QuestThemeData, BrandTheme]);

  const { apiType } = useContext(QuestContext.Context);
  let GeneralFunctions = new General("mixpanel", apiType);
  useEffect(() => {
    GeneralFunctions.fireTrackingEvent(
      "quest_leaderboard_offline_loaded",
      "leaderboard_offline"
    );
    setLeaderboardData({
      data: offlineFormData,
    });
  }, [offlineFormData]);

  return (
    <div style={{ background: "white", maxWidth: "500px", borderRadius: themeManager.getContainerStyles().borderRadius }}>
      {leaderboardData && (
        <LeaderBoardShow
          leaderboardUserData={leaderboardData}
          memberShip={[]}
          styleConfig={styleConfig}
          brandTheme={BrandTheme}
          questThemeData={QuestThemeData}
          FirstRankIconImage={FirstRankIconImage}
          SecondRankIconImage={SecondRankIconImage}
          ThirdRankIconImage={ThirdRankIconImage}
          IsTopRank={IsTopRank}
          isXpImage={isXpImage}
          rewardHead={rewardHead}
          presentUserRank={presentUserRank}
          showFooter={showFooter}
          onUserClick={onUserClick}
          customUnit={customUnit}
          customUnitImage={customUnitImage}
        />
      )}
    </div>
  );
};

export default LeaderBoardOffline;
